import React from "react";
import '../css/Bulles_Etablissements_Professionnels_Selectionnes.css'


const toggleExpand = (setExpandedBubbles, sous_categorie) => {
    setExpandedBubbles((prevExpandedBubbles) => {
      const newExpandedBubbles = [...prevExpandedBubbles];
      if (newExpandedBubbles.includes(sous_categorie)) {
        return newExpandedBubbles.filter(c => c !== sous_categorie);
      }
      newExpandedBubbles.push(sous_categorie);
      return newExpandedBubbles;
    });
  };


const scrollBubbles = (bubbleContainerRef, setScrollPosition, direction) => {
    if (bubbleContainerRef.current) {
    const container = bubbleContainerRef.current;
    const scrollAmount = direction === 'left' ? -500 : 500;
    container.scrollBy({ left: scrollAmount, behavior: 'smooth' });

    setTimeout(()=>{setScrollPosition(container.scrollLeft + scrollAmount)}, 400);
    }
};


const Bulles_Etablissements_Professionnels_Selectionnes = ({
  selectedSousCategories,
  selectedProfessions,
  expandedBubbles,
  showMenuLateral,
  bubbleContainerRef,
  handleRemoveSousCategory,
  handleRemoveProfession,
  setScrollPosition,
  setExpandedBubbles
}) => {
  return (
    <div>
      {/* Left Arrow */}
      {(selectedSousCategories.length > 0 || selectedProfessions.length > 0) && (
        <div
          className={`arrow arrow-left ${
            selectedSousCategories.length > 0 || selectedProfessions.length > 0
              ? "slide-in"
              : ""
          }`}
          onClick={() => scrollBubbles(bubbleContainerRef, setScrollPosition,"left")}
        >
          <img
            style={{
              width: "auto",
              height: "auto",
              maxWidth: "50%",
              maxHeight: "50%",
            }}
            src="fleche_gauche.png"
            alt="Left Arrow"
          />
        </div>
      )}

      {/* Bubble Container */}
      <div
        className="sous-category-bubbles"
        style={{ width: showMenuLateral ? "50%" : "70%" }}
        ref={bubbleContainerRef}
      >
        {selectedSousCategories.map((sous_categorie, index) => (
          <button
            key={`sous-category-${index}`}
            className={`sous-category-bubble slide-in ${
              expandedBubbles.includes(sous_categorie) ? "expanded" : ""
            }`}
            style={{
              animationDelay: `${
                expandedBubbles.indexOf(sous_categorie) * 0.1
              }s`,
            }}
            onClick={() => toggleExpand(setExpandedBubbles, sous_categorie)}
          >
            <span>{sous_categorie}</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleRemoveSousCategory(sous_categorie);
              }}
            >
              <img src="croix-bubble.png" alt="Remove" />
            </button>
          </button>
        ))}

        {selectedProfessions.map((profession, index) => (
          <button
            key={`profession-${index}`}
            className={`sous-category-bubble slide-in ${
              expandedBubbles.includes(profession) ? "expanded" : ""
            }`}
            style={{
              animationDelay: `${
                expandedBubbles.indexOf(profession) * 0.1
              }s`,
            }}
            onClick={() => toggleExpand(profession)}
          >
            <span>{profession}</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleRemoveProfession(profession);
              }}
            >
              <img src="croix-bubble.png" alt="Remove" />
            </button>
          </button>
        ))}
      </div>

      {/* Right Arrow */}
      {(selectedSousCategories.length > 0 || selectedProfessions.length > 0) && (
        <div
          className={`arrow arrow-right ${
            selectedSousCategories.length > 0 || selectedProfessions.length > 0
              ? "slide-in"
              : ""
          }`}
          style={{ right: showMenuLateral ? "37%" : "16%" }}
          onClick={() => scrollBubbles(bubbleContainerRef, setScrollPosition,"right")}
        >
          <img
            style={{
              width: "auto",
              height: "auto",
              maxWidth: "50%",
              maxHeight: "50%",
            }}
            src="fleche_droite.png"
            alt="Right Arrow"
          />
        </div>
      )}
    </div>
  );
};

export default Bulles_Etablissements_Professionnels_Selectionnes;
